import(/* webpackMode: "eager" */ "/codebuild/output/src927551835/src/src/app/global-error.tsx");
